import { jsx as _jsx } from "react/jsx-runtime";
import { TooltipContent } from "@faire/retailer-visitor-shared/features/PointOfSale/components/PDPInventory/TooltipContent";
import { Tooltip } from "@faire/retailer-visitor-shared/features/PointOfSale/components/Tooltip";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { TooltipTypography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var OpenSizingInventoryHeader = function(param) {
    var isEmpty = param.isEmpty;
    var _usePOSSummary = usePOSSummary(), posCompanyName = _usePOSSummary.name;
    if (isEmpty) {
        return /*#__PURE__*/ _jsx(Spacer, {
            size: "1x"
        });
    }
    return /*#__PURE__*/ _jsx(Column, {
        align: "flex-start",
        children: /*#__PURE__*/ _jsx(Tooltip, {
            target: /*#__PURE__*/ _jsx(TooltipTypography, {
                align: "left",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "Uy63G3",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "In "
                        },
                        {
                            type: 1,
                            value: "posCompanyName"
                        }
                    ],
                    values: {
                        posCompanyName: posCompanyName
                    }
                })
            }),
            children: /*#__PURE__*/ _jsx(TooltipContent, {})
        })
    });
};
